module.exports = __webpack_public_path__ + "assets/webproduction-6f142242fb6a8d4938d46b09e412c8e4.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Website/assets/webproduction.png
// module id = 642
// module chunks = 0 1